import { useState } from 'react';
import QuoteList from './QuoteList';
import QuoteForm from './QuoteForm';

export default function QuoteSection() {
  return (
    <section id="quote" className="py-14 md:py-20 px-4 md:px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-4xl font-extrabold text-center mb-8 md:mb-12 text-gray-950">
          우리집 익스프레스,
          <br className="md:hidden" />
          <span className="text-teal-600"> 간편 견적 상담</span>
        </h2>
        
        <div className="grid lg:grid-cols-2 gap-6 md:gap-8">
          <QuoteList />
          <QuoteForm />
        </div>
      </div>
    </section>
  );
}
